<template>
  <div class="DivInfotranparent">
    <CCard class="CardInfotranparent">
      <div class="LessonContentTable">
        <div class="HeadContent">
          <h1 class="TopicHead">TEXT</h1>
          <h2 class="Topic">pin yin</h2>
          <h2 class="Topic">漢字</h2>
        </div>
        <div class="justifycontent">
          <div class="LineBorder"></div>
        </div>

        <!-- <div>
          <CRow class="ButtonNextPrev">
            <div class="BTNNext">
              <CButton
                @click="NextBTN"
                class="BTNNextText TextInfoAssign"
                block
                color="light"
                shape="pill"
              >NEXT</CButton>
            </div>
          </CRow>
        </div> -->
      </div>
    </CCard>
  </div>
</template>

<script>
import TextComponent from './TextComponent'
export default {
  name: "infoTranparent",
  components:{
    TextComponent
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },}
};
</script>

<style>
.HeadContent{
    padding-bottom: 50px;
}
.justifycontent {
  justify-content: center;
}
.LineBorder {
  width: 100%;
  border: 1px solid;
  height: 0rem;
}
.DivInfotranparent {
  display: flex;
}
.CardInfotranparent {
  justify-content: center;
  min-width: 300px;
  border: none;
}
.card-header {
  border-bottom: 0px !important;
}
.TopicHead {
  text-align: center;
  font-size: 50px;
  padding-top: 50px;
}
.Topic {
  text-align: center;
  font-size: 30px;
}
/* .BTNNextText {
  color: white;
  background-color: #349e54;
  width: 250px;
  height: 100px;
  font-size: 30px;
}
.ButtonNextPrev {
  justify-content: center;
  padding-top: 100px;
  padding-bottom: 50px; */
/* } */
</style>